export default __webpack_public_path__ + "static/media/menu-logo-light.1320dac6.png";